import * as t from 'io-ts';
import { ITypeExecutionItem } from 'ws-voice-infinity-global-module/lib/interfaces';
import { InitiatorPerson, InitiatorPersonType } from 'ws-voice-infinity-global-module/lib/models';
import TYPE_EXECUTION, { TypeExecutionType } from '../enums/typeExecution';

export const ExecutionType = t.interface(
    {
        attachments: t.union([t.array(t.object), t.null]),
        content: t.union([t.string, t.null]),
        createDate: t.union([t.string, t.number, t.null]),
        hide: t.boolean,
        id: t.string,
        initiatorUserId: t.union([t.string, t.null]),
        read: t.boolean,
        type: t.union([TypeExecutionType, t.null]),
        initiatorPerson: t.union([InitiatorPersonType, t.null]),
    },
);

export interface ExecutionDTO extends t.TypeOf<typeof ExecutionType> {
}

export class Execution {
    attachmentIds: string[];
    content: string | null;
    createDate: Date | null;
    hide: boolean;
    id: string;
    initiatorUserId: string | null;
    read: boolean;
    type: ITypeExecutionItem | null;
    initiatorPerson: InitiatorPerson | null;

    constructor(params: ExecutionDTO) {
        this.attachmentIds = params.attachments && params.attachments.length ? params.attachments.map((el: any) => el.nodeId) : [];
        this.content = params.content;
        this.createDate = params.createDate ? new Date(params.createDate) : null;
        this.hide = params.hide;
        this.id = params.id;
        this.initiatorUserId = params.initiatorUserId;
        this.read = params.read;
        this.type = params.type ? TYPE_EXECUTION[params.type] : TYPE_EXECUTION.CREATED;
        this.initiatorPerson = params.initiatorPerson ? new InitiatorPerson(params.initiatorPerson) : null;
    }
}
